// DO NOT CHANGE THIS FILE MANUALLY.
// It was generated using scripts/lib/template.ts
import * as React from "react";
export const IconCircleCheckmark = ({
  size,
  onClick,
  ...otherProps
}: React.SVGProps<SVGSVGElement> & {
  /** @deprecated - wrap in a `<DDSButton variant="ghost">` put the onClick on there */ onClick?: never;
  size?: "xs" | "s" | "m" | "l" | "xl" | "xxl";
}) => {
  const props = {
    ...otherProps,
    className: "mdsIcon " + (size || "") + " " + (otherProps.className || ""),
  };
  return (
    <svg {...props} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
      <path d="M32 8C17.191 8 8 17.191 8 32C8 46.809 17.191 56 32 56C46.809 56 56 46.809 56 32C56 17.191 46.809 8 32 8ZM46.8492 25.7913L29.5251 43.1155C28.7616 43.879 27.8138 43.879 27.0502 43.1155L17.1508 33.2159C16.3872 32.4524 16.3872 31.5046 17.1508 30.7411L19.5268 28.3651C20.3479 27.5439 21.3372 27.5819 22.0929 28.4636L28.2877 35.6909L41.9015 20.9425C42.6606 20.1201 43.6334 20.1006 44.4249 20.8921L46.8492 23.3165C47.6128 24.08 47.6128 25.0278 46.8492 25.7913Z" />
    </svg>
  );
};
